/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { PharmacyIndentStatus } from 'app/shared/model/enumerations/pharmacy-indent-status.model';
import { PharmacyAddedByType } from 'app/shared/model/enumerations/pharmacy-added-by-type.model';
import { PharmacyIndentType } from 'app/shared/model/enumerations/pharmacy-indent-type.model';
import { SupplierType } from 'app/shared/model/enumerations/supplier-type.model';
import { ConsumerType } from 'app/shared/model/enumerations/consumer-type.model';

export interface IPharmacyExternalOrder {
  id?: string;
  status?: keyof typeof PharmacyIndentStatus | null;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  addedById?: string | null;
  modifiedById?: string | null;
  fulfilledById?: string | null;
  addedByType?: keyof typeof PharmacyAddedByType | null;
  modifiedByType?: keyof typeof PharmacyAddedByType | null;
  fulfilledByType?: keyof typeof PharmacyAddedByType | null;
  orderDirection?: keyof typeof PharmacyIndentType | null;
  supplierId?: string;
  supplierIdType?: keyof typeof SupplierType;
  consumerId?: string;
  consumerType?: keyof typeof ConsumerType;
  createdById?: string | null;
  createdByType?: keyof typeof PharmacyAddedByType | null;
}

export const defaultValue: Readonly<IPharmacyExternalOrder> = {
  active: false,
};
